import React, { useState } from 'react';
import '../styles/InteractiveLogoSVG.css';
import { Link } from 'react-router-dom';

const InteractiveLogoSVG2 = () => {
  const [activeService, setActiveService] = useState(null);

  const services = [
    { id: 'pr', name: 'PR', path: '/hizmetlerimiz/pr', angle: 270 },
    { id: 'sosyal-medya', name: 'Sosyal Medya', path: '/hizmetlerimiz/sosyal-medya', angle: 198 },
    { id: 'produksiyon', name: 'Prodüksiyon', path: '/hizmetlerimiz/produksiyon', angle: 126 },
    { id: 'organizasyon', name: 'Organizasyon', path: '/hizmetlerimiz/organizasyon', angle: 342 },
    { id: 'studyo', name: 'Stüdyo Hizmeti', path: '/hizmetlerimiz/studyo-hizmeti', angle: 54 }
  ];

  const CENTER_X = 400;
  const CENTER_Y = 250;
  const RADIUS = 175;
  const SERVICE_R = 50;

  const handleMouseEnter = (id) => setActiveService(id);
  const handleMouseLeave = () => setActiveService(null);

  return (
    <div className="interactive-logo-svg-container">
      <svg className="interactive-logo-svg" viewBox="0 0 800 500">
        {/* Hizmet çemberleri */}
        {services.map((service) => {
          const rad = (service.angle * Math.PI) / 180;
          const cx = CENTER_X + RADIUS * Math.cos(rad);
          const cy = CENTER_Y + RADIUS * Math.sin(rad);

          return (
            <React.Fragment key={service.id}>
              <line
                className="connector-line"
                x1={CENTER_X}
                y1={CENTER_Y}
                x2={cx}
                y2={cy}
              />
              <Link to={service.path}>
                <circle
                  className={`service-circle${activeService === service.id ? ' active' : ''}`}
                  cx={cx}
                  cy={cy}
                  r={SERVICE_R}
                  onMouseEnter={() => handleMouseEnter(service.id)}
                  onMouseLeave={handleMouseLeave}
                />
                <text
                  className="service-label"
                  x={cx}
                  y={cy}
                  dominantBaseline="middle"
                  textAnchor="middle"
                >
                  {service.name}
                </text>
              </Link>
            </React.Fragment>
          );
        })}

        {/* Merkez daire */}
        <Link to={'/hakkimizda'}>
        <circle className="center-circle" cx={CENTER_X} cy={CENTER_Y} r={80} fill="url(#orangeGradient)" />
        <text className="center-text" x={CENTER_X} y={CENTER_Y} dominantBaseline="middle" textAnchor="middle">
          5N1PR
        </text>
        </Link>

        <defs>
          <linearGradient id="orangeGradient" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#fd8f28" />
            <stop offset="100%" stopColor="#fbd961" />
          </linearGradient>
          <linearGradient id="grayGradient" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#343b3e" />
            <stop offset="100%" stopColor="#9c9ea0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default InteractiveLogoSVG2;
